import { ReactElement } from 'react';

import {
  AF, AL, DZ, AS, AD, AO, AI, AG, AR, AM, AW, AU, AT, AZ,
  BS, BH, BD, BB, BY, BE, BZ, BJ, BM, BT, BO, BA, BW, BR, IO, VG,
  BN, BG, BF, BI, KH, CM, CA, BQ, KY, CF, TD, CL, CN, CX, CC, CO,
  KM, CK, CR, HR, CU, CW, CY, CZ, CD, DK, DJ, DM, DO, EC, EG, SV,
  GQ, ER, EE, SZ, ET, FK, FO, FJ, FI, FR, PF, GA, GM, GE, DE, GH,
  GI, GR, GL, GD, GU, GT, GG, GN, GW, GY, HT, HN, HK, HU, IS, IN,
  ID, IR, IQ, IE, IM, IT, JM, JP, JE, JO, KZ, KE, KI, KW, KG, LA,
  LV, LB, LS, LR, LY, LI, LT, LU, MO, MG, MW, MY, MV, ML, MT, MH,
  MQ, MR, MU, MX, FM, MD, MC, MN, ME, MS, MA, MZ, MM, NA, NR, NP,
  NL, NZ, NI, NE, NG, NU, NF, KP, MK, MP, NO, OM, PK, PW, PS, PA,
  PG, PY, PE, PH, PN, PL, PT, PR, QA, RO, RU, RW, BL, KN, LC, VC,
  WS, SM, SA, SN, RS, SC, SL, SG, SX, SK, SI, SB, SO, ZA, KR, SS,
  ES, LK, SR, SE, CH, SY, ST, TW, TJ, TZ, TH, TL, TG, TK, TO, TT,
  TN, TR, TM, TC, TV, UG, UA, AE, GB, US, VI, UY, UZ, VU, VE, VN,
  EH, YE, ZM, ZW, AX,
} from '@unified-checkout/design-system/icons/countries';

export const COUNTRIES_LIST: {
  name: string;
  icon: string | ReactElement;
  code: string;
  iso: string;
  currency: string;
}[] = [
  {
    name: 'Afghanistan',
    icon: AF,
    code: '+93',
    iso: 'AF',
    currency: 'AFN',
  },
  {
    name: 'Albania',
    icon: AL,
    code: '+355',
    iso: 'AL',
    currency: 'ALL',
  },
  {
    name: 'Algeria',
    icon: DZ,
    code: '+213',
    iso: 'DZ',
    currency: 'DZD',
  },
  {
    name: 'American Samoa',
    icon: AS,
    code: '+1684',
    iso: 'AS',
    currency: 'USD',
  },
  {
    name: 'Andorra',
    icon: AD,
    code: '+376',
    iso: 'AD',
    currency: 'EUR',
  },
  {
    name: 'Angola',
    icon: AO,
    code: '+244',
    iso: 'AO',
    currency: 'AOA',
  },
  {
    name: 'Anguilla',
    icon: AI,
    code: '+1264',
    iso: 'AI',
    currency: 'XCD',
  },
  {
    name: 'Antarctica',
    icon: 'https://hatscripts.github.io/circle-flags/flags/aq.svg',
    code: '',
    iso: 'AQ',
    currency: '',
  },
  {
    name: 'Antigua and Barbuda',
    icon: AG,
    code: '+1268',
    iso: 'AG',
    currency: 'XCD',
  },
  {
    name: 'Argentina',
    icon: AR,
    code: '+54',
    iso: 'AR',
    currency: 'ARS',
  },
  {
    name: 'Armenia',
    icon: AM,
    code: '+374',
    iso: 'AM',
    currency: 'AMD',
  },
  {
    name: 'Aruba',
    icon: AW,
    code: '+297',
    iso: 'AW',
    currency: 'AWG',
  },
  {
    name: 'Australia',
    icon: AU,
    code: '+61',
    iso: 'AU',
    currency: 'AUD',
  },
  {
    name: 'Austria',
    icon: AT,
    code: '+43',
    iso: 'AT',
    currency: 'EUR',
  },
  {
    name: 'Azerbaijan',
    icon: AZ,
    code: '+994',
    iso: 'AZ',
    currency: 'AZN',
  },
  {
    name: 'Bahamas',
    icon: BS,
    code: '+1242',
    iso: 'BS',
    currency: 'BSD',
  },
  {
    name: 'Bahrain',
    icon: BH,
    code: '+973',
    iso: 'BH',
    currency: 'BHD',
  },
  {
    name: 'Bangladesh',
    icon: BD,
    code: '+880',
    iso: 'BD',
    currency: 'BDT',
  },
  {
    name: 'Barbados',
    icon: BB,
    code: '+1246',
    iso: 'BB',
    currency: 'BBD',
  },
  {
    name: 'Belarus',
    icon: BY,
    code: '+375',
    iso: 'BY',
    currency: 'BYN',
  },
  {
    name: 'Belgium',
    icon: BE,
    code: '+32',
    iso: 'BE',
    currency: 'EUR',
  },
  {
    name: 'Belize',
    icon: BZ,
    code: '+501',
    iso: 'BZ',
    currency: 'BZD',
  },
  {
    name: 'Benin',
    icon: BJ,
    code: '+229',
    iso: 'BJ',
    currency: 'XOF',
  },
  {
    name: 'Bermuda',
    icon: BM,
    code: '+1441',
    iso: 'BM',
    currency: 'BMD',
  },
  {
    name: 'Bhutan',
    icon: BT,
    code: '+975',
    iso: 'BT',
    currency: 'BTN',
  },
  {
    name: 'Bolivia',
    icon: BO,
    code: '+591',
    iso: 'BO',
    currency: 'BOB',
  },
  {
    name: 'Bosnia and Herzegovina',
    icon: BA,
    code: '+387',
    iso: 'BA',
    currency: 'BAM',
  },
  {
    name: 'Botswana',
    icon: BW,
    code: '+267',
    iso: 'BW',
    currency: 'BWP',
  },
  {
    name: 'Bouvet Island',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bv.svg',
    code: '+47',
    iso: 'BV',
    currency: '',
  },
  {
    name: 'Brazil',
    icon: BR,
    code: '+55',
    iso: 'BR',
    currency: 'BRL',
  },
  {
    name: 'British Indian Ocean Territory',
    icon: IO,
    code: '+246',
    iso: 'IO',
    currency: 'USD',
  },
  {
    name: 'British Virgin Islands',
    icon: VG,
    code: '+1284',
    iso: 'VG',
    currency: 'USD',
  },
  {
    name: 'Brunei',
    icon: BN,
    code: '+673',
    iso: 'BN',
    currency: 'BND',
  },
  {
    name: 'Bulgaria',
    icon: BG,
    code: '+359',
    iso: 'BG',
    currency: 'BGN',
  },
  {
    name: 'Burkina Faso',
    icon: BF,
    code: '+226',
    iso: 'BF',
    currency: 'XOF',
  },
  {
    name: 'Burundi',
    icon: BI,
    code: '+257',
    iso: 'BI',
    currency: 'BIF',
  },
  {
    name: 'Cambodia',
    icon: KH,
    code: '+855',
    iso: 'KH',
    currency: 'KHR',
  },
  {
    name: 'Cameroon',
    icon: CM,
    code: '+237',
    iso: 'CM',
    currency: 'XAF',
  },
  {
    name: 'Canada',
    icon: CA,
    code: '+1',
    iso: 'CA',
    currency: 'CAD',
  },
  {
    name: 'Cape Verde',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cv.svg',
    code: '+238',
    iso: 'CV',
    currency: 'CVE',
  },
  {
    name: 'Caribbean Netherlands',
    icon: BQ,
    code: '+599',
    iso: 'BES islands',
    currency: 'USD',
  },
  {
    name: 'Cayman Islands',
    icon: KY,
    code: '+1345',
    iso: 'KY',
    currency: 'KYD',
  },
  {
    name: 'Central African Republic',
    icon: CF,
    code: '+236',
    iso: 'CF',
    currency: 'XAF',
  },
  {
    name: 'Chad',
    icon: TD,
    code: '+235',
    iso: 'TD',
    currency: 'XAF',
  },
  {
    name: 'Chile',
    icon: CL,
    code: '+56',
    iso: 'CL',
    currency: 'CLP',
  },
  {
    name: 'China',
    icon: CN,
    code: '+86',
    iso: 'CN',
    currency: 'CNY',
  },
  {
    name: 'Christmas Island',
    icon: CX,
    code: '+61',
    iso: 'CX',
    currency: 'AUD',
  },
  {
    name: 'Cocos (Keeling) Islands',
    icon: CC,
    code: '+61',
    iso: 'CC',
    currency: 'AUD',
  },
  {
    name: 'Colombia',
    icon: CO,
    code: '+57',
    iso: 'CO',
    currency: 'COP',
  },
  {
    name: 'Comoros',
    icon: KM,
    code: '+269',
    iso: 'KM',
    currency: 'KMF',
  },
  {
    name: 'Cook Islands',
    icon: CK,
    code: '+682',
    iso: 'CK',
    currency: 'CKD',
  },
  {
    name: 'Costa Rica',
    icon: CR,
    code: '+506',
    iso: 'CR',
    currency: 'CRC',
  },
  {
    name: 'Croatia',
    icon: HR,
    code: '+385',
    iso: 'HR',
    currency: 'EUR',
  },
  {
    name: 'Cuba',
    icon: CU,
    code: '+53',
    iso: 'CU',
    currency: 'CUC',
  },
  {
    name: 'Curaçao',
    icon: CW,
    code: '+599',
    iso: 'CW',
    currency: 'ANG',
  },
  {
    name: 'Cyprus',
    icon: CY,
    code: '+357',
    iso: 'CY',
    currency: 'EUR',
  },
  {
    name: 'Czechia',
    icon: CZ,
    code: '+420',
    iso: 'CZ',
    currency: 'CZK',
  },
  {
    name: 'DR Congo',
    icon: CD,
    code: '+243',
    iso: 'CD',
    currency: 'CDF',
  },
  {
    name: 'Denmark',
    icon: DK,
    code: '+45',
    iso: 'DK',
    currency: 'DKK',
  },
  {
    name: 'Djibouti',
    icon: DJ,
    code: '+253',
    iso: 'DJ',
    currency: 'DJF',
  },
  {
    name: 'Dominica',
    icon: DM,
    code: '+1767',
    iso: 'DM',
    currency: 'XCD',
  },
  {
    name: 'Dominican Republic',
    icon: DO,
    code: '+1',
    iso: 'DO',
    currency: 'DOP',
  },
  {
    name: 'Ecuador',
    icon: EC,
    code: '+593',
    iso: 'EC',
    currency: 'USD',
  },
  {
    name: 'Egypt',
    icon: EG,
    code: '+20',
    iso: 'EG',
    currency: 'EGP',
  },
  {
    name: 'El Salvador',
    icon: SV,
    code: '+503',
    iso: 'SV',
    currency: 'USD',
  },
  {
    name: 'Equatorial Guinea',
    icon: GQ,
    code: '+240',
    iso: 'GQ',
    currency: 'XAF',
  },
  {
    name: 'Eritrea',
    icon: ER,
    code: '+291',
    iso: 'ER',
    currency: 'ERN',
  },
  {
    name: 'Estonia',
    icon: EE,
    code: '+372',
    iso: 'EE',
    currency: 'EUR',
  },
  {
    name: 'Eswatini',
    icon: SZ,
    code: '+268',
    iso: 'SZ',
    currency: 'SZL',
  },
  {
    name: 'Ethiopia',
    icon: ET,
    code: '+251',
    iso: 'ET',
    currency: 'ETB',
  },
  {
    name: 'Falkland Islands',
    icon: FK,
    code: '+500',
    iso: 'FK',
    currency: 'FKP',
  },
  {
    name: 'Faroe Islands',
    icon: FO,
    code: '+298',
    iso: 'FO',
    currency: 'DKK',
  },
  {
    name: 'Fiji',
    icon: FJ,
    code: '+679',
    iso: 'FJ',
    currency: 'FJD',
  },
  {
    name: 'Finland',
    icon: FI,
    code: '+358',
    iso: 'FI',
    currency: 'EUR',
  },
  {
    name: 'France',
    icon: FR,
    code: '+33',
    iso: 'FR',
    currency: 'EUR',
  },
  {
    name: 'French Guiana',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gf.svg',
    code: '+594',
    iso: 'GF',
    currency: 'EUR',
  },
  {
    name: 'French Polynesia',
    icon: PF,
    code: '+689',
    iso: 'PF',
    currency: 'XPF',
  },
  {
    name: 'French Southern and Antarctic Lands',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tf.svg',
    code: '+262',
    iso: 'TF',
    currency: 'EUR',
  },
  {
    name: 'Gabon',
    icon: GA,
    code: '+241',
    iso: 'GA',
    currency: 'XAF',
  },
  {
    name: 'Gambia',
    icon: GM,
    code: '+220',
    iso: 'GM',
    currency: 'GMD',
  },
  {
    name: 'Georgia',
    icon: GE,
    code: '+995',
    iso: 'GE',
    currency: 'GEL',
  },
  {
    name: 'Germany',
    icon: DE,
    code: '+49',
    iso: 'DE',
    currency: 'EUR',
  },
  {
    name: 'Ghana',
    icon: GH,
    code: '+233',
    iso: 'GH',
    currency: 'GHS',
  },
  {
    name: 'Gibraltar',
    icon: GI,
    code: '+350',
    iso: 'GI',
    currency: 'GIP',
  },
  {
    name: 'Greece',
    icon: GR,
    code: '+30',
    iso: 'GR',
    currency: 'EUR',
  },
  {
    name: 'Greenland',
    icon: GL,
    code: '+299',
    iso: 'GL',
    currency: 'DKK',
  },
  {
    name: 'Grenada',
    icon: GD,
    code: '+1473',
    iso: 'GD',
    currency: 'XCD',
  },
  {
    name: 'Guadeloupe',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gp.svg',
    code: '+590',
    iso: 'GP',
    currency: 'EUR',
  },
  {
    name: 'Guam',
    icon: GU,
    code: '+1671',
    iso: 'GU',
    currency: 'USD',
  },
  {
    name: 'Guatemala',
    icon: GT,
    code: '+502',
    iso: 'GT',
    currency: 'GTQ',
  },
  {
    name: 'Guernsey',
    icon: GG,
    code: '+44',
    iso: 'GG',
    currency: 'GBP',
  },
  {
    name: 'Guinea',
    icon: GN,
    code: '+224',
    iso: 'GN',
    currency: 'GNF',
  },
  {
    name: 'Guinea-Bissau',
    icon: GW,
    code: '+245',
    iso: 'GW',
    currency: 'XOF',
  },
  {
    name: 'Guyana',
    icon: GY,
    code: '+592',
    iso: 'GY',
    currency: 'GYD',
  },
  {
    name: 'Haiti',
    icon: HT,
    code: '+509',
    iso: 'HT',
    currency: 'HTG',
  },
  {
    name: 'Heard Island and McDonald Islands',
    icon: 'https://hatscripts.github.io/circle-flags/flags/hm.svg',
    code: '',
    iso: 'HM',
    currency: '',
  },
  {
    name: 'Honduras',
    icon: HN,
    code: '+504',
    iso: 'HN',
    currency: 'HNL',
  },
  {
    name: 'Hong Kong',
    icon: HK,
    code: '+852',
    iso: 'HK',
    currency: 'HKD',
  },
  {
    name: 'Hungary',
    icon: HU,
    code: '+36',
    iso: 'HU',
    currency: 'HUF',
  },
  {
    name: 'Iceland',
    icon: IS,
    code: '+354',
    iso: 'IS',
    currency: 'ISK',
  },
  {
    name: 'India',
    icon: IN,
    code: '+91',
    iso: 'IN',
    currency: 'INR',
  },
  {
    name: 'Indonesia',
    icon: ID,
    code: '+62',
    iso: 'ID',
    currency: 'IDR',
  },
  {
    name: 'Iran',
    icon: IR,
    code: '+98',
    iso: 'IR',
    currency: 'IRR',
  },
  {
    name: 'Iraq',
    icon: IQ,
    code: '+964',
    iso: 'IQ',
    currency: 'IQD',
  },
  {
    name: 'Ireland',
    icon: IE,
    code: '+353',
    iso: 'IE',
    currency: 'EUR',
  },
  {
    name: 'Isle of Man',
    icon: IM,
    code: '+44',
    iso: 'IM',
    currency: 'GBP',
  },
  {
    name: 'Italy',
    icon: IT,
    code: '+39',
    iso: 'IT',
    currency: 'EUR',
  },
  {
    name: 'Ivory Coast',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ci.svg',
    code: '+225',
    iso: 'CI',
    currency: 'XOF',
  },
  {
    name: 'Jamaica',
    icon: JM,
    code: '+1876',
    iso: 'JM',
    currency: 'JMD',
  },
  {
    name: 'Japan',
    icon: JP,
    code: '+81',
    iso: 'JP',
    currency: 'JPY',
  },
  {
    name: 'Jersey',
    icon: JE,
    code: '+44',
    iso: 'JE',
    currency: 'GBP',
  },
  {
    name: 'Jordan',
    icon: JO,
    code: '+962',
    iso: 'JO',
    currency: 'JOD',
  },
  {
    name: 'Kazakhstan',
    icon: KZ,
    code: '+7',
    iso: 'KZ',
    currency: 'KZT',
  },
  {
    name: 'Kenya',
    icon: KE,
    code: '+254',
    iso: 'KE',
    currency: 'KES',
  },
  {
    name: 'Kiribati',
    icon: KI,
    code: '+686',
    iso: 'KI',
    currency: 'AUD',
  },
  {
    name: 'Kosovo',
    icon: 'https://hatscripts.github.io/circle-flags/flags/xk.svg',
    code: '+383',
    iso: 'XK',
    currency: 'EUR',
  },
  {
    name: 'Kuwait',
    icon: KW,
    code: '+965',
    iso: 'KW',
    currency: 'KWD',
  },
  {
    name: 'Kyrgyzstan',
    icon: KG,
    code: '+996',
    iso: 'KG',
    currency: 'KGS',
  },
  {
    name: 'Laos',
    icon: LA,
    code: '+856',
    iso: 'LA',
    currency: 'LAK',
  },
  {
    name: 'Latvia',
    icon: LV,
    code: '+371',
    iso: 'LV',
    currency: 'EUR',
  },
  {
    name: 'Lebanon',
    icon: LB,
    code: '+961',
    iso: 'LB',
    currency: 'LBP',
  },
  {
    name: 'Lesotho',
    icon: LS,
    code: '+266',
    iso: 'LS',
    currency: 'LSL',
  },
  {
    name: 'Liberia',
    icon: LR,
    code: '+231',
    iso: 'LR',
    currency: 'LRD',
  },
  {
    name: 'Libya',
    icon: LY,
    code: '+218',
    iso: 'LY',
    currency: 'LYD',
  },
  {
    name: 'Liechtenstein',
    icon: LI,
    code: '+423',
    iso: 'LI',
    currency: 'CHF',
  },
  {
    name: 'Lithuania',
    icon: LT,
    code: '+370',
    iso: 'LT',
    currency: 'EUR',
  },
  {
    name: 'Luxembourg',
    icon: LU,
    code: '+352',
    iso: 'LU',
    currency: 'EUR',
  },
  {
    name: 'Macau',
    icon: MO,
    code: '+853',
    iso: 'MO',
    currency: 'MOP',
  },
  {
    name: 'Madagascar',
    icon: MG,
    code: '+261',
    iso: 'MG',
    currency: 'MGA',
  },
  {
    name: 'Malawi',
    icon: MW,
    code: '+265',
    iso: 'MW',
    currency: 'MWK',
  },
  {
    name: 'Malaysia',
    icon: MY,
    code: '+60',
    iso: 'MY',
    currency: 'MYR',
  },
  {
    name: 'Maldives',
    icon: MV,
    code: '+960',
    iso: 'MV',
    currency: 'MVR',
  },
  {
    name: 'Mali',
    icon: ML,
    code: '+223',
    iso: 'ML',
    currency: 'XOF',
  },
  {
    name: 'Malta',
    icon: MT,
    code: '+356',
    iso: 'MT',
    currency: 'EUR',
  },
  {
    name: 'Marshall Islands',
    icon: MH,
    code: '+692',
    iso: 'MH',
    currency: 'USD',
  },
  {
    name: 'Martinique',
    icon: MQ,
    code: '+596',
    iso: 'MQ',
    currency: 'EUR',
  },
  {
    name: 'Mauritania',
    icon: MR,
    code: '+222',
    iso: 'MR',
    currency: 'MRU',
  },
  {
    name: 'Mauritius',
    icon: MU,
    code: '+230',
    iso: 'MU',
    currency: 'MUR',
  },
  {
    name: 'Mayotte',
    icon: 'https://hatscripts.github.io/circle-flags/flags/yt.svg',
    code: '+262',
    iso: 'YT',
    currency: 'EUR',
  },
  {
    name: 'Mexico',
    icon: MX,
    code: '+52',
    iso: 'MX',
    currency: 'MXN',
  },
  {
    name: 'Micronesia',
    icon: FM,
    code: '+691',
    iso: 'FM',
    currency: 'USD',
  },
  {
    name: 'Moldova',
    icon: MD,
    code: '+373',
    iso: 'MD',
    currency: 'MDL',
  },
  {
    name: 'Monaco',
    icon: MC,
    code: '+377',
    iso: 'MC',
    currency: 'EUR',
  },
  {
    name: 'Mongolia',
    icon: MN,
    code: '+976',
    iso: 'MN',
    currency: 'MNT',
  },
  {
    name: 'Montenegro',
    icon: ME,
    code: '+382',
    iso: 'ME',
    currency: 'EUR',
  },
  {
    name: 'Montserrat',
    icon: MS,
    code: '+1664',
    iso: 'MS',
    currency: 'XCD',
  },
  {
    name: 'Morocco',
    icon: MA,
    code: '+212',
    iso: 'MA',
    currency: 'MAD',
  },
  {
    name: 'Mozambique',
    icon: MZ,
    code: '+258',
    iso: 'MZ',
    currency: 'MZN',
  },
  {
    name: 'Myanmar',
    icon: MM,
    code: '+95',
    iso: 'MM',
    currency: 'MMK',
  },
  {
    name: 'Namibia',
    icon: NA,
    code: '+264',
    iso: 'NA',
    currency: 'NAD',
  },
  {
    name: 'Nauru',
    icon: NR,
    code: '+674',
    iso: 'NR',
    currency: 'AUD',
  },
  {
    name: 'Nepal',
    icon: NP,
    code: '+977',
    iso: 'NP',
    currency: 'NPR',
  },
  {
    name: 'Netherlands',
    icon: NL,
    code: '+31',
    iso: 'NL',
    currency: 'EUR',
  },
  {
    name: 'New Caledonia',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nc.svg',
    code: '+687',
    iso: 'NC',
    currency: 'XPF',
  },
  {
    name: 'New Zealand',
    icon: NZ,
    code: '+64',
    iso: 'NZ',
    currency: 'NZD',
  },
  {
    name: 'Nicaragua',
    icon: NI,
    code: '+505',
    iso: 'NI',
    currency: 'NIO',
  },
  {
    name: 'Niger',
    icon: NE,
    code: '+227',
    iso: 'NE',
    currency: 'XOF',
  },
  {
    name: 'Nigeria',
    icon: NG,
    code: '+234',
    iso: 'NG',
    currency: 'NGN',
  },
  {
    name: 'Niue',
    icon: NU,
    code: '+683',
    iso: 'NU',
    currency: 'NZD',
  },
  {
    name: 'Norfolk Island',
    icon: NF,
    code: '+672',
    iso: 'NF',
    currency: 'AUD',
  },
  {
    name: 'North Korea',
    icon: KP,
    code: '+850',
    iso: 'KP',
    currency: 'KPW',
  },
  {
    name: 'North Macedonia',
    icon: MK,
    code: '+389',
    iso: 'MK',
    currency: 'MKD',
  },
  {
    name: 'Northern Mariana Islands',
    icon: MP,
    code: '+1670',
    iso: 'MP',
    currency: 'USD',
  },
  {
    name: 'Norway',
    icon: NO,
    code: '+47',
    iso: 'NO',
    currency: 'NOK',
  },
  {
    name: 'Oman',
    icon: OM,
    code: '+968',
    iso: 'OM',
    currency: 'OMR',
  },
  {
    name: 'Pakistan',
    icon: PK,
    code: '+92',
    iso: 'PK',
    currency: 'PKR',
  },
  {
    name: 'Palau',
    icon: PW,
    code: '+680',
    iso: 'PW',
    currency: 'USD',
  },
  {
    name: 'Palestine',
    icon: PS,
    code: '+970',
    iso: 'PS',
    currency: 'JOD',
  },
  {
    name: 'Panama',
    icon: PA,
    code: '+507',
    iso: 'PA',
    currency: 'PAB',
  },
  {
    name: 'Papua New Guinea',
    icon: PG,
    code: '+675',
    iso: 'PG',
    currency: 'PGK',
  },
  {
    name: 'Paraguay',
    icon: PY,
    code: '+595',
    iso: 'PY',
    currency: 'PYG',
  },
  {
    name: 'Peru',
    icon: PE,
    code: '+51',
    iso: 'PE',
    currency: 'PEN',
  },
  {
    name: 'Philippines',
    icon: PH,
    code: '+63',
    iso: 'PH',
    currency: 'PHP',
  },
  {
    name: 'Pitcairn Islands',
    icon: PN,
    code: '+64',
    iso: 'PN',
    currency: 'NZD',
  },
  {
    name: 'Poland',
    icon: PL,
    code: '+48',
    iso: 'PL',
    currency: 'PLN',
  },
  {
    name: 'Portugal',
    icon: PT,
    code: '+351',
    iso: 'PT',
    currency: 'EUR',
  },
  {
    name: 'Puerto Rico',
    icon: PR,
    code: '+1',
    iso: 'PR',
    currency: 'USD',
  },
  {
    name: 'Qatar',
    icon: QA,
    code: '+974',
    iso: 'QA',
    currency: 'QAR',
  },
  {
    name: 'Republic of the Congo',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cg.svg',
    code: '+242',
    iso: 'CG',
    currency: 'XAF',
  },
  {
    name: 'Romania',
    icon: RO,
    code: '+40',
    iso: 'RO',
    currency: 'RON',
  },
  {
    name: 'Russia',
    icon: RU,
    code: '+7',
    iso: 'RU',
    currency: 'RUB',
  },
  {
    name: 'Rwanda',
    icon: RW,
    code: '+250',
    iso: 'RW',
    currency: 'RWF',
  },
  {
    name: 'Réunion',
    icon: 'https://hatscripts.github.io/circle-flags/flags/re.svg',
    code: '+262',
    iso: 'RE',
    currency: 'EUR',
  },
  {
    name: 'Saint Barthélemy',
    icon: BL,
    code: '+590',
    iso: 'BL',
    currency: 'EUR',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sh.svg',
    code: '+2',
    iso: 'Saint Helena',
    currency: 'GBP',
  },
  {
    name: 'Saint Kitts and Nevis',
    icon: KN,
    code: '+1869',
    iso: 'KN',
    currency: 'XCD',
  },
  {
    name: 'Saint Lucia',
    icon: LC,
    code: '+1758',
    iso: 'LC',
    currency: 'XCD',
  },
  {
    name: 'Saint Martin',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mf.svg',
    code: '+590',
    iso: 'MF',
    currency: 'EUR',
  },
  {
    name: 'Saint Pierre and Miquelon',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pm.svg',
    code: '+508',
    iso: 'PM',
    currency: 'EUR',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    icon: VC,
    code: '+1784',
    iso: 'VC',
    currency: 'XCD',
  },
  {
    name: 'Samoa',
    icon: WS,
    code: '+685',
    iso: 'WS',
    currency: 'WST',
  },
  {
    name: 'San Marino',
    icon: SM,
    code: '+378',
    iso: 'SM',
    currency: 'EUR',
  },
  {
    name: 'Saudi Arabia',
    icon: SA,
    code: '+966',
    iso: 'SA',
    currency: 'SAR',
  },
  {
    name: 'Senegal',
    icon: SN,
    code: '+221',
    iso: 'SN',
    currency: 'XOF',
  },
  {
    name: 'Serbia',
    icon: RS,
    code: '+381',
    iso: 'RS',
    currency: 'RSD',
  },
  {
    name: 'Seychelles',
    icon: SC,
    code: '+248',
    iso: 'SC',
    currency: 'SCR',
  },
  {
    name: 'Sierra Leone',
    icon: SL,
    code: '+232',
    iso: 'SL',
    currency: 'SLL',
  },
  {
    name: 'Singapore',
    icon: SG,
    code: '+65',
    iso: 'SG',
    currency: 'SGD',
  },
  {
    name: 'Sint Maarten',
    icon: SX,
    code: '+1721',
    iso: 'SX',
    currency: 'ANG',
  },
  {
    name: 'Slovakia',
    icon: SK,
    code: '+421',
    iso: 'SK',
    currency: 'EUR',
  },
  {
    name: 'Slovenia',
    icon: SI,
    code: '+386',
    iso: 'SI',
    currency: 'EUR',
  },
  {
    name: 'Solomon Islands',
    icon: SB,
    code: '+677',
    iso: 'SB',
    currency: 'SBD',
  },
  {
    name: 'Somalia',
    icon: SO,
    code: '+252',
    iso: 'SO',
    currency: 'SOS',
  },
  {
    name: 'South Africa',
    icon: ZA,
    code: '+27',
    iso: 'ZA',
    currency: 'ZAR',
  },
  {
    name: 'South Georgia',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gs.svg',
    code: '+500',
    iso: 'GS',
    currency: 'SHP',
  },
  {
    name: 'South Korea',
    icon: KR,
    code: '+82',
    iso: 'KR',
    currency: 'KRW',
  },
  {
    name: 'South Sudan',
    icon: SS,
    code: '+211',
    iso: 'SS',
    currency: 'SSP',
  },
  {
    name: 'Spain',
    icon: ES,
    code: '+34',
    iso: 'ES',
    currency: 'EUR',
  },
  {
    name: 'Sri Lanka',
    icon: LK,
    code: '+94',
    iso: 'LK',
    currency: 'LKR',
  },
  {
    name: 'Sudan',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sd.svg',
    code: '+249',
    iso: 'SD',
    currency: 'SDG',
  },
  {
    name: 'Suriname',
    icon: SR,
    code: '+597',
    iso: 'SR',
    currency: 'SRD',
  },
  {
    name: 'Svalbard and Jan Mayen',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sj.svg',
    code: '+4779',
    iso: 'SJ',
    currency: 'NOK',
  },
  {
    name: 'Sweden',
    icon: SE,
    code: '+46',
    iso: 'SE',
    currency: 'SEK',
  },
  {
    name: 'Switzerland',
    icon: CH,
    code: '+41',
    iso: 'CH',
    currency: 'CHF',
  },
  {
    name: 'Syria',
    icon: SY,
    code: '+963',
    iso: 'SY',
    currency: 'SYP',
  },
  {
    name: 'São Tomé and Príncipe',
    icon: ST,
    code: '+239',
    iso: 'ST',
    currency: 'STN',
  },
  {
    name: 'Taiwan',
    icon: TW,
    code: '+886',
    iso: 'TW',
    currency: 'TWD',
  },
  {
    name: 'Tajikistan',
    icon: TJ,
    code: '+992',
    iso: 'TJ',
    currency: 'TJS',
  },
  {
    name: 'Tanzania',
    icon: TZ,
    code: '+255',
    iso: 'TZ',
    currency: 'TZS',
  },
  {
    name: 'Thailand',
    icon: TH,
    code: '+66',
    iso: 'TH',
    currency: 'THB',
  },
  {
    name: 'Timor-Leste',
    icon: TL,
    code: '+670',
    iso: 'TL',
    currency: 'USD',
  },
  {
    name: 'Togo',
    icon: TG,
    code: '+228',
    iso: 'TG',
    currency: 'XOF',
  },
  {
    name: 'Tokelau',
    icon: TK,
    code: '+690',
    iso: 'TK',
    currency: 'NZD',
  },
  {
    name: 'Tonga',
    icon: TO,
    code: '+676',
    iso: 'TO',
    currency: 'TOP',
  },
  {
    name: 'Trinidad and Tobago',
    icon: TT,
    code: '+1868',
    iso: 'TT',
    currency: 'TTD',
  },
  {
    name: 'Tunisia',
    icon: TN,
    code: '+216',
    iso: 'TN',
    currency: 'TND',
  },
  {
    name: 'Turkey',
    icon: TR,
    code: '+90',
    iso: 'TR',
    currency: 'TRY',
  },
  {
    name: 'Turkmenistan',
    icon: TM,
    code: '+993',
    iso: 'TM',
    currency: 'TMT',
  },
  {
    name: 'Turks and Caicos Islands',
    icon: TC,
    code: '+1649',
    iso: 'TC',
    currency: 'USD',
  },
  {
    name: 'Tuvalu',
    icon: TV,
    code: '+688',
    iso: 'TV',
    currency: 'AUD',
  },
  {
    name: 'Uganda',
    icon: UG,
    code: '+256',
    iso: 'UG',
    currency: 'UGX',
  },
  {
    name: 'Ukraine',
    icon: UA,
    code: '+380',
    iso: 'UA',
    currency: 'UAH',
  },
  {
    name: 'United Arab Emirates',
    icon: AE,
    code: '+971',
    iso: 'AE',
    currency: 'AED',
  },
  {
    name: 'United Kingdom',
    icon: GB,
    code: '+44',
    iso: 'GB',
    currency: 'GBP',
  },
  {
    name: 'United States',
    icon: US,
    code: '+1',
    iso: 'US',
    currency: 'USD',
  },
  {
    name: 'United States Minor Outlying Islands',
    icon: 'https://hatscripts.github.io/circle-flags/flags/um.svg',
    code: '+268',
    iso: 'UM',
    currency: 'USD',
  },
  {
    name: 'United States Virgin Islands',
    icon: VI,
    code: '+1340',
    iso: 'VI',
    currency: 'USD',
  },
  {
    name: 'Uruguay',
    icon: UY,
    code: '+598',
    iso: 'UY',
    currency: 'UYU',
  },
  {
    name: 'Uzbekistan',
    icon: UZ,
    code: '+998',
    iso: 'UZ',
    currency: 'UZS',
  },
  {
    name: 'Vanuatu',
    icon: VU,
    code: '+678',
    iso: 'VU',
    currency: 'VUV',
  },
  {
    name: 'Vatican City',
    icon: 'https://hatscripts.github.io/circle-flags/flags/va.svg',
    code: '+3',
    iso: 'VA',
    currency: 'EUR',
  },
  {
    name: 'Venezuela',
    icon: VE,
    code: '+58',
    iso: 'VE',
    currency: 'VES',
  },
  {
    name: 'Vietnam',
    icon: VN,
    code: '+84',
    iso: 'VN',
    currency: 'VND',
  },
  {
    name: 'Wallis and Futuna',
    icon: 'https://hatscripts.github.io/circle-flags/flags/wf.svg',
    code: '+681',
    iso: 'WF',
    currency: 'XPF',
  },
  {
    name: 'Western Sahara',
    icon: EH,
    code: '+2',
    iso: 'EH',
    currency: 'DZD',
  },
  {
    name: 'Yemen',
    icon: YE,
    code: '+967',
    iso: 'YE',
    currency: 'YER',
  },
  {
    name: 'Zambia',
    icon: ZM,
    code: '+260',
    iso: 'ZM',
    currency: 'ZMW',
  },
  {
    name: 'Zimbabwe',
    icon: ZW,
    code: '+263',
    iso: 'ZW',
    currency: 'ZWL',
  },
  {
    name: 'Åland Islands',
    icon: AX,
    code: '+35818',
    iso: 'AX',
    currency: 'EUR',
  },
];
